import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import DashboardPlugin from '@/plugins/dashboard-plugin';
import vSelect from 'vue-select';
import VueTheMask from 'vue-the-mask';
import VoerroTagsInput from '@voerro/vue-tagsinput';
import { mapGetters, mapMutations } from 'vuex';
import { getStatsigClient } from '@/plugins/statsigClient';
import { createPinia, PiniaVuePlugin } from 'pinia';
import Vidle from 'v-idle';

import './assets/tailwind.css';

Vue.use(PiniaVuePlugin); // Required for Vue 2 compatibility

const pinia = createPinia();

Vue.use(Vidle);
Vue.component('v-select', vSelect);
Vue.component('tags-input', VoerroTagsInput);
Vue.use(DashboardPlugin);
Vue.use(VueTheMask);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  const updateBackground = () => {
    if (store.getters['account/isLoggedIn']) {
      // document.body.classList.remove('bg-default');
      document.body.style.cssText += 'background-image: none !important';
    }
  };

  window.onpopstate = (event: any) => {
    updateBackground();
  };
  updateBackground();

  next();
});

const statsigState = Vue.observable({
  initialized: false,
  loading: true,
});

Vue.prototype.$statsigState = statsigState;

(async () => {
  if (!statsigState.initialized) {
    try {
      await getStatsigClient();
    } catch (error) {
      console.error('Statsig initialization failed in created:', error);
    } finally {
      statsigState.loading = false;
      statsigState.initialized = true;
    }
  }
  new Vue({
    data () {
      return {
        isLoading: false,
        conceptIsVisible: false,
      };
    },
    router,
    store,
    computed: {
      ...mapGetters({
        getUserClient: 'account/getUserClient',
        getLocale: 'app/getLocale',
      }),

      secondaryColor (): any {
        if (this.getUserClient !== null) {
          const api_theme = this.getUserClient.attributes.theme;

          const themeParse = JSON.parse(api_theme);

          return themeParse.secondary_color;
        }

        const themeParse = JSON.parse('{"header_bg_color":"#26314f","primary_color":"#ff6b00","secondary_color":"#18a0fb"}');

        return themeParse.secondary_color;
      },
      primaryColor (): any {
        if (this.getUserClient !== null) {
          const api_theme = this.getUserClient.attributes.theme;

          const themeParse = JSON.parse(api_theme);

          return themeParse.primary_color;
        }

        const themeParse = JSON.parse('{"header_bg_color":"#26314f","primary_color":"#ff6b00","secondary_color":"#18a0fb"}');

        return themeParse.primary_color;
      },
      HeaderColor (): any {
        if (this.getUserClient !== null) {
          const api_theme = this.getUserClient.attributes.theme;

          const themeParse = JSON.parse(api_theme);

          return themeParse.header_bg_color;
        }

        const themeParse = JSON.parse('{"header_bg_color":"#26314f","primary_color":"#ff6b00","secondary_color":"#18a0fb"}');

        return themeParse.header_bg_color;
      },
    },
    watch: {
      getLocale: {
        immediate: true,
        handler (newLocale: string) {
          const isRTL = newLocale === 'ar_SA';
          if (isRTL) {
            document.body.classList.add('rtl');
            document.documentElement.setAttribute('dir', 'rtl');
          } else {
            document.body.classList.remove('rtl');
            document.documentElement.setAttribute('dir', 'ltr');
          }
        },
      },
    },
    mounted () {
      const primary = document.documentElement;
      const header = document.documentElement;
      const secondary = document.documentElement;

      primary.style.setProperty('--primary-color', this.primaryColor as string);
      header.style.setProperty('--header-color', this.HeaderColor as string);
      secondary.style.setProperty('--secondary-color', this.secondaryColor as string);

      const api_background = this.getUserClient?.attributes.extras;

      if (api_background) {
        const backgroundParse = JSON.parse(api_background);
        document.body.style.cssText += `background-image:url(${backgroundParse.background})`;
      }
    },

    render: (h) => h(App),
  }).$mount('#app');
})();
